import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddLoansModal from "./AddLoansModal";
import LoanService from "../../../../services/LoanService";
import "./style.scss";

const tabStatus = {
	has_loans: "ACTIVE",
	not_started: "NOT_STARTED",
	history: "COMPLETED",
};

const statusOptions = [
	{ label: "Pending", value: "PENDING" },
	{ label: "Not Started", value: "NOT_STARTED" },
	{ label: "Active", value: "ACTIVE" },
	{ label: "Completed", value: "COMPLETED" },
];

const typeOptions = [
	{ label: "Add to Payroll", value: "ADD_TO_PAYROLL" },
	{ label: "Cash", value: "CASH" },
	{ label: "Cheque", value: "CHEQUE" },
	{ label: "Deposit", value: "DEPOSIT" },
];

const LoanManagement = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const tabs = ["has_loans", "not_started", "history"];
	const [selectTab, setSelectTab] = useState("has_loans");

	const [search, setSearch] = useState("");
	const [filterStatus, setFilterStatus] = useState(null);
	const [filterType, setFilterType] = useState(null);

	const param = {
		tab: selectTab,
		...(search ? { search } : {}),
		...(filterStatus ? { status: filterStatus.value } : {}),
		...(filterType ? { type: filterType.value } : {}),
	};

	return (
		<div className="department">
			<Card className="mb-3">
				<Card.Body className="search-card d-flex justify-content-between p-3 align-items-center">
					<div className="input-group w-75">
						<div className="custom-tabs-div">
							{tabs?.map((tab, index) => (
								<p
									key={index}
									className={`${tab === selectTab ? "activeP" : ""}`}
									onClick={() => {
										setSelectTab(tab);
										setShouldUpdate((prev) => !prev);
									}}>
									<span></span> {Translate[lang][tab]}
								</p>
							))}
						</div>
					</div>
					{selectTab === "has_loans" && (
						<div className="add-department">
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => setAddModal(true)}>
								<i className="la la-plus mx-1"></i>
								{Translate[lang]?.add} {Translate[lang]?.loans}
							</Button>
						</div>
					)}
				</Card.Body>
			</Card>

			<Card className="mb-3">
				<Card.Body className="p-3">
					<Row className="align-items-end g-3">
						<Col md={4}>
							<input
								type="text"
								className="form-control"
								placeholder={Translate[lang]?.search_by_employee_name || "Search by employee name"}
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
						</Col>
						<Col md={3}>
							<Select
								isClearable
								placeholder={Translate[lang]?.status}
								options={statusOptions}
								value={filterStatus}
								onChange={setFilterStatus}
							/>
						</Col>
						<Col md={3}>
							<Select
								isClearable
								placeholder={Translate[lang]?.type}
								options={typeOptions}
								value={filterType}
								onChange={setFilterType}
							/>
						</Col>
						<Col md={2}>
							<Button
								variant="primary"
								className="w-100"
								onClick={() => setShouldUpdate((prev) => !prev)}>
								{Translate[lang]?.search}
							</Button>
						</Col>
					</Row>
				</Card.Body>
			</Card>

			<Row>
				<Col lg={12}>
					<Card>
						<Card.Body className={`${hasData === 0 && "text-center"}`}>
							{loading && (
								<div style={{ height: "300px" }}>
									<Loader />
								</div>
							)}
							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>I.D</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.employee_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.department}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.loan}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.type}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.no_of_installments}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.no_of_payments_made}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.remaining}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.installment_amount}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.payment_start_date}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.note}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.status}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.actions}</strong>
											</th>
										</tr>
									</thead>
									<tbody className="table-body">
										{data?.map((item, index) => (
											<CardItem
												key={item.id || index}
												index={index}
												item={item}
												selectTab={selectTab}
												setShouldUpdate={setShouldUpdate}
											/>
										))}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={new LoanService()}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								param={param}
							/>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddLoansModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
				/>
			)}
		</div>
	);
};

export default LoanManagement;
